/* eslint-disable react/no-unknown-property */
export default function EnIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
    >
      <mask
        id="mask0_642_8764"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="24"
      >
        <rect width="32" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_642_8764)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H32V24H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 14.6666V16.6666H32V14.6666H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 18.3334V20.3334H32V18.3334H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 7.33337V9.33337H32V7.33337H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 22V24H32V22H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11V13H32V11H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V2H32V0H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.66663V5.66663H32V3.66663H0Z"
          fill="#E31D1C"
        />
        <rect width="20" height="13" fill="#2E42A5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.72221 2.93871L0.996331 3.44759L1.2414 2.54198L0.59668 1.96807H1.43877L1.7212 1.229L2.05237 1.96807H2.77022L2.20619 2.54198L2.42455 3.44759L1.72221 2.93871ZM5.72221 2.93871L4.99633 3.44759L5.2414 2.54198L4.59668 1.96807H5.43877L5.7212 1.229L6.05237 1.96807H6.77022L6.20619 2.54198L6.42455 3.44759L5.72221 2.93871ZM8.99633 3.44759L9.72221 2.93871L10.4245 3.44759L10.2062 2.54198L10.7702 1.96807H10.0524L9.7212 1.229L9.43877 1.96807H8.59668L9.2414 2.54198L8.99633 3.44759ZM13.7222 2.93871L12.9963 3.44759L13.2414 2.54198L12.5967 1.96807H13.4388L13.7212 1.229L14.0524 1.96807H14.7702L14.2062 2.54198L14.4245 3.44759L13.7222 2.93871ZM0.996331 7.44759L1.72221 6.93871L2.42455 7.44759L2.20619 6.54198L2.77022 5.96807H2.05237L1.7212 5.229L1.43877 5.96807H0.59668L1.2414 6.54198L0.996331 7.44759ZM5.72221 6.93871L4.99633 7.44759L5.2414 6.54198L4.59668 5.96807H5.43877L5.7212 5.229L6.05237 5.96807H6.77022L6.20619 6.54198L6.42455 7.44759L5.72221 6.93871ZM8.99633 7.44759L9.72221 6.93871L10.4245 7.44759L10.2062 6.54198L10.7702 5.96807H10.0524L9.7212 5.229L9.43877 5.96807H8.59668L9.2414 6.54198L8.99633 7.44759ZM13.7222 6.93871L12.9963 7.44759L13.2414 6.54198L12.5967 5.96807H13.4388L13.7212 5.229L14.0524 5.96807H14.7702L14.2062 6.54198L14.4245 7.44759L13.7222 6.93871ZM0.996331 11.4476L1.72221 10.9387L2.42455 11.4476L2.20619 10.542L2.77022 9.96807H2.05237L1.7212 9.229L1.43877 9.96807H0.59668L1.2414 10.542L0.996331 11.4476ZM5.72221 10.9387L4.99633 11.4476L5.2414 10.542L4.59668 9.96807H5.43877L5.7212 9.229L6.05237 9.96807H6.77022L6.20619 10.542L6.42455 11.4476L5.72221 10.9387ZM8.99633 11.4476L9.72221 10.9387L10.4245 11.4476L10.2062 10.542L10.7702 9.96807H10.0524L9.7212 9.229L9.43877 9.96807H8.59668L9.2414 10.542L8.99633 11.4476ZM13.7222 10.9387L12.9963 11.4476L13.2414 10.542L12.5967 9.96807H13.4388L13.7212 9.229L14.0524 9.96807H14.7702L14.2062 10.542L14.4245 11.4476L13.7222 10.9387ZM16.9963 3.44759L17.7222 2.93871L18.4245 3.44759L18.2062 2.54198L18.7702 1.96807H18.0524L17.7212 1.229L17.4388 1.96807H16.5967L17.2414 2.54198L16.9963 3.44759ZM17.7222 6.93871L16.9963 7.44759L17.2414 6.54198L16.5967 5.96807H17.4388L17.7212 5.229L18.0524 5.96807H18.7702L18.2062 6.54198L18.4245 7.44759L17.7222 6.93871ZM16.9963 11.4476L17.7222 10.9387L18.4245 11.4476L18.2062 10.542L18.7702 9.96807H18.0524L17.7212 9.229L17.4388 9.96807H16.5967L17.2414 10.542L16.9963 11.4476ZM3.72221 4.93871L2.99633 5.44759L3.2414 4.54198L2.59668 3.96807H3.43877L3.7212 3.229L4.05237 3.96807H4.77022L4.20619 4.54198L4.42455 5.44759L3.72221 4.93871ZM6.99633 5.44759L7.72221 4.93871L8.42455 5.44759L8.20619 4.54198L8.77022 3.96807H8.05237L7.7212 3.229L7.43877 3.96807H6.59668L7.2414 4.54198L6.99633 5.44759ZM11.7222 4.93871L10.9963 5.44759L11.2414 4.54198L10.5967 3.96807H11.4388L11.7212 3.229L12.0524 3.96807H12.7702L12.2062 4.54198L12.4245 5.44759L11.7222 4.93871ZM2.99633 9.44759L3.72221 8.93871L4.42455 9.44759L4.20619 8.54198L4.77022 7.96807H4.05237L3.7212 7.229L3.43877 7.96807H2.59668L3.2414 8.54198L2.99633 9.44759ZM7.72221 8.93871L6.99633 9.44759L7.2414 8.54198L6.59668 7.96807H7.43877L7.7212 7.229L8.05237 7.96807H8.77022L8.20619 8.54198L8.42455 9.44759L7.72221 8.93871ZM10.9963 9.44759L11.7222 8.93871L12.4245 9.44759L12.2062 8.54198L12.7702 7.96807H12.0524L11.7212 7.229L11.4388 7.96807H10.5967L11.2414 8.54198L10.9963 9.44759ZM15.7222 4.93871L14.9963 5.44759L15.2414 4.54198L14.5967 3.96807H15.4388L15.7212 3.229L16.0524 3.96807H16.7702L16.2062 4.54198L16.4245 5.44759L15.7222 4.93871ZM14.9963 9.44759L15.7222 8.93871L16.4245 9.44759L16.2062 8.54198L16.7702 7.96807H16.0524L15.7212 7.229L15.4388 7.96807H14.5967L15.2414 8.54198L14.9963 9.44759Z"
          fill="#F7FCFF"
        />
      </g>
    </svg>
  );
}
